import React, { useMemo } from 'react';
import PostCard from './PostCard';
import PostEmptyState from './PostEmptyStates';
import { POST_STATUSES } from '../../services/SocialPostService';

export default function PostDraftsList({
  posts = [],
  onEdit,
  onApprove,
  onQueue,
  onCancel,
  onRetry,
  onClick,
  loading = false,
}) {
  const drafts = useMemo(
    () => posts.filter((p) => p.status === POST_STATUSES.draft),
    [posts]
  );

  if (loading) {
    return (
      <div className="space-y-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="animate-pulse h-28 bg-zinc-100 rounded-2xl" />
        ))}
      </div>
    );
  }

  if (drafts.length === 0) {
    return <PostEmptyState type="drafts" />;
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-2">
        <span className="text-xs font-semibold text-zinc-500 uppercase tracking-wider">
          {drafts.length} draft{drafts.length !== 1 ? 's' : ''}
        </span>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {drafts.map((post) => (
          <PostCard
            key={post._id}
            post={post}
            onEdit={onEdit}
            onApprove={onApprove}
            onQueue={onQueue}
            onCancel={onCancel}
            onRetry={onRetry}
            onClick={onClick}
          />
        ))}
      </div>
    </div>
  );
}
